import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';

import {PoDynamicFormField, PoLookupColumn, PoLookupFilter, PoLookupFilteredItemsParams} from '@po-ui/ng-components';
import {environment} from 'src/environments/environment';
import { Fornecedor } from '../interface/fornecedor';

@Injectable({
  providedIn: 'root'
})
export class FornecedorLookupService implements PoLookupFilter {
  url = `${environment.urlApiProtheus}/wsrfornecedor`;

  constructor(private httpClient: HttpClient) {
  }

  getFilteredItems(filteredParams: PoLookupFilteredItemsParams): Observable<any> {
    const {filterParams, advancedFilters, ...restFilteredItemsParams} = filteredParams;
    const params = {...restFilteredItemsParams, ...filterParams, ...advancedFilters};

    return this.httpClient.get(this.url, {params});
  }

  getObjectByValue(value: string, modelo: string): Observable<Fornecedor> {
    return this.httpClient.get<Fornecedor>(`${this.url}/${value}/${modelo}`);
  }

  getObjectByRecno(value: number, modelo: string): Observable<Fornecedor> {
    return this.httpClient.get<Fornecedor>(`${this.url}/recno/${value}/${modelo}`);
  }

  getAdvancedFilter(): Array<PoDynamicFormField> {
    return [
      {property: 'CA2CGC', optional: true, gridColumns: 6, label: 'CNPJ/CPF'},
    ];
  }

  getColumnsFilter(): Array<PoLookupColumn> {
    return [
      {property: 'CA2COD' , label: 'Codigo'  , width: '15%'},
      {property: 'CA2LOJA', label: 'Loja'    , width: '5%'},
      {property: 'CA2NOME', label: 'Nome'    , width: '45%'},
      {property: 'CA2CGC' , label: 'CNPJ/CPF', width: '35%'},
    ];
  }

  getFieldFormater(value: any) {
    return `${value.CA2COD} - ${value.CA2LOJA} - ${value.CA2NOME}`;
  }

}
